var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"overlay-wrapper"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('i',{staticClass:"fas fa-3x fa-sync-alt fa-spin"}),_c('div',{staticClass:"text-bold pt-2"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }